import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import CreditCardGold from '../../../svg/CreditCardGold.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';
import NumberFormat from 'react-number-format';

class Billing extends Component {
  state = {
    payment: {
      cc_number: '',
      expiration_date: '',
      code: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { cc_number, expiration_date, code } = this.state.payment;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Billing Information"
          subline="Please provide a method of payment"
          icon={<CreditCardGold />}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
        >
          <div className="row">
            <div className="row__item row__item--full">
              <NumberFormat
                customInput={FormsyInputMui}
                name="cc_number"
                placeholder="Card Number"
                autoComplete="cc-number"
                value={cc_number}
                onValueChange={this.handleCardChange}
                showError={this.state.formIsInvalid}
                required
                format={this.cardFormat}
              />
            </div>
          </div>

          <div className="row">
            <div className="onboarding-new__small-text-field">
              <NumberFormat
                customInput={FormsyInputMui}
                name="expiration_date"
                placeholder="Exp"
                autoComplete="cc-exp"
                value={expiration_date}
                onValueChange={this.handleExpChange}
                showError={this.state.formIsInvalid}
                required
                format={this.cardExpiryFormat}
              />
            </div>
            <div className="onboarding-new__small-text-field">
              <FormsyInputMui
                name="code"
                type="number"
                placeholder="CVC"
                autoComplete="cc-csc"
                value={code}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
                validations={{
                  isNumeric: true,
                  customValidation: function(values, value) {
                    if (values.cc_number) {
                      // Amex begins with '34' or '37'
                      const isAmex =
                        values.cc_number.slice(0, 2) === '34' ||
                        values.cc_number.slice(0, 2) === '37';

                      return isAmex ? value.length === 4 : value.length === 3;
                    } else {
                      return true;
                    }
                  }
                }}
                disabled={cc_number.length < 3}
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleCardChange = ({ value }) => {
    this.setState({
      payment: { ...this.state.payment, cc_number: value }
    });
  };

  handleExpChange = ({ value }) => {
    this.setState({
      payment: { ...this.state.payment, expiration_date: value }
    });
  };

  limit = (val, max) => {
    if (val.length === 1 && val[0] > max[0]) {
      val = '0' + val;
    }

    if (val.length === 2) {
      if (Number(val) === 0) {
        val = '01';

        //this can happen when user paste number
      } else if (val > max) {
        val = max;
      }
    }

    return val;
  };

  isAmex = val => {
    // Amex begins with '34' or '37'
    return val.slice(0, 2) === '34' || val.slice(0, 2) === '37';
  };

  cardFormat = val => {
    let formattedVal = val.split('');
    if (!this.isAmex(val)) {
      // 16 digit card formatting here.
      if (val.length > 4) formattedVal.splice(4, 0, ' ');
      if (val.length > 9) formattedVal.splice(9, 0, ' ');
      if (val.length > 14) formattedVal.splice(14, 0, ' ');

      return formattedVal.join('').slice(0, 19);
    } else {
      // return amex formatting here
      if (val.length > 4) formattedVal.splice(4, 0, ' ');
      if (val.length > 11) formattedVal.splice(11, 0, ' ');

      return formattedVal.join('').slice(0, 17);
    }
  };

  cardExpiryFormat = val => {
    let month = this.limit(val.substring(0, 2), '12');
    let year = val.substring(2, 4);

    return month + (year.length ? '/' + year : '');
  };

  handleChange = e => {
    let { name, value } = e.target;
    const { cc_number } = this.state.payment;

    if (name === 'expiration_date') {
      // no non-digits allowed in zip_code
      if (isNaN(value)) return;
      if (value.length > 4) return;
    }

    if (name === 'code') {
      // no non-digits allowed in cvc code
      if (isNaN(value)) return;

      // Amex code is 4 chars.  Visa/MC has 3.
      const length = this.isAmex(cc_number) ? 4 : 3;
      if (value.length > length) return;
      value = value.toUpperCase();
    }

    this.setState({
      payment: { ...this.state.payment, [name]: value }
    });
  };

  mutatePayload = payment => {
    const month = payment.expiration_date.slice(0, 2);
    const year = payment.expiration_date.slice(2);
    const expiration_date = `20${year}-${month}`;

    return { ...payment, expiration_date };
  };

  ingestPayload = payment => {
    const month = payment.expiration_date.slice(5);
    const year = payment.expiration_date.slice(2, 4);
    const expiration_date = `${year}${month}`;

    return { ...payment, expiration_date };
  };

  handleClientUpdate = () => {
    const { payment } = this.state;

    const updatedClient = {
      payment: this.mutatePayload(payment)
    };
    this.props.updateClient(updatedClient);
  };

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client.payment !== client.payment) {
      const { payment = {} } = client;
      const isEmpty = Object.keys(payment).length === 0;
      if (!isEmpty) {
        this.setState({ payment: this.ingestPayload(payment) });
      }
    }

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }

  componentDidMount() {
    const { client } = this.props;
    const { payment = {} } = client;

    const isEmpty = Object.keys(payment).length === 0;
    if (!isEmpty) {
      this.setState({ payment: this.ingestPayload(payment) });
    }
  }
}

export default Billing;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Billing.js